import { render, staticRenderFns } from "./TenderPotentialBidders.vue?vue&type=template&id=3f8bf63e"
import script from "./TenderPotentialBidders.vue?vue&type=script&lang=js"
export * from "./TenderPotentialBidders.vue?vue&type=script&lang=js"
import style0 from "./TenderPotentialBidders.vue?vue&type=style&index=0&id=3f8bf63e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports